// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Menu arrow button for sidbar */
.buttonContainerSidbar {
    position: fixed;
    top: 0.8em;
    right: 25px;
    z-index: 38;
}

.menuButton {
    width: 16px;
    height: 5vh;
    cursor: pointer;
    border: none;
    filter: invert();
    padding-right: 0.4em;
}

.menuButton:active {
    box-shadow: 0 0 0 0 white;
    animation: globalPressAnimation 0.1s 1 linear;
}

.menuButton:hover {
    filter: invert(48%) sepia(13%) saturate(3207%) hue-rotate(130deg)
        brightness(95%) contrast(80%);
}

/* sidbar component */

.sideNavbarText {
    padding-top: 0.2em;
    list-style-type: none;
    text-align: center;
    padding-left: 0em;
}

.sideNavbarText h3 {
    padding: 1em;
}

.sideNavbarImages {
    padding-top: 2em;
    list-style-type: none;
    text-align: center;
    padding-left: 0em;
}

.sideContainerParent {
    display: flex;
    align-items: center;
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: var(--sidbarColor);
    z-index: 37;
    padding-left: 1em;
    min-width: 240px;
    min-height: 100vh;
    margin: 0;
    animation: slideIn 0.1s 1 linear;
}

@keyframes slideIn {
    0% {
        min-width: 0px;
    }

    50% {
        min-width: 240px;
    }

    to {
        min-width: 240px;
    }
}

.sideBarSettingsIcon {
    max-width: 2em;
}

.sideContainerParentDesktopSmall {
    display: block;
    align-items: center;
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: var(--sidbarColor);
    z-index: 30;
    padding-left: 0.6em;
    min-width: 0.5em;
    min-height: 100vh;
    animation: slideOut 0.2s 1 linear;
    margin: 0;
}

@keyframes slideOut {
    0% {
        min-width: 240px;
    }

    50% {
        min-width: 0.5em;
    }

    to {
        min-width: 0.5em;
    }
}

.iconSizeMenu {
    max-width: 3.5em;
    padding-right: 0.9em;
    padding-left: 0.9em;
    filter: invert();
    cursor: pointer;
    box-sizing: border-box; /* Ensure padding does not affect layout */
    justify-content: center;
    align-items: center;
}

.iconSizeMenu:active {
    animation: globalPressAnimation 0.1s 1 linear;
}

.iconSizeMenu:hover {
    filter: invert(48%) sepia(13%) saturate(3207%) hue-rotate(130deg)
        brightness(95%) contrast(80%);
}

.sideNavbarTextContainerSmall {
    padding-top: 8em;
}

.iconSizeMenuActive {
    background-color: var(--sidbarSelectorColor);
    box-shadow: 0 -2px 0 5px var(--sidbarSelectorColor);
    cursor: pointer;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    box-sizing: border-box; /* Ensure padding does not affect layout */
    transition:
        background-color 0.2s ease,
        padding-top 0.2s ease;
}

.MenuActive {
    padding: 0.5em;
    background-color: var(--sidbarSelectorColor);
    padding-top: 0.8em;

    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    text-align: left;
    max-height: 2.4em;
    transform: scale(0.8);
}

.MenuActiveNo:hover {
    padding: 0.5em;
    background-color: var(--sidbarSelectorColor);
    padding-top: 0.8em;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
}

.MenuActiveNo {
    padding: 0.5em;
    padding-top: 0.8em;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    text-align: left;
    max-height: 2.4em;
    transform: scale(0.8);
}

.sideNavbarImage {
    max-height: 5em;
    padding-bottom: 2em;
}

.sideNavbarImageSmall {
    max-height: 5em;
    padding-bottom: 2em;
    padding-top: 5em;
}

.activeLiSide {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    cursor: pointer;
    color: white;
    font-size: 1.3em;
    padding-bottom: 1em;
    display: inline-block;
    vertical-align: middle;
}

.notActiveSide {
    display: inline-block;
    vertical-align: middle;
    color: white;
    font-size: 1.3em;
    padding-bottom: 1em;
}

.notActiveSide:hover {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    text-align: left;
    cursor: pointer;
}

.logoutButtonSideMenu {
    max-width: 30px;
    max-height: 30px;
    filter: invert();
    cursor: pointer;
}

.logoutButtonSideMenuSmall {
    max-width: 30px;
    max-height: 30px;
    filter: invert();
    position: absolute;
    bottom: 1em;
    left: 1.2em;
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Menus/SideMenu/sideMenu.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;IACI,eAAe;IACf,UAAU;IACV,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,6CAA6C;AACjD;;AAEA;IACI;qCACiC;AACrC;;AAEA,qBAAqB;;AAErB;IACI,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,QAAQ;IACR,MAAM;IACN,SAAS;IACT,oCAAoC;IACpC,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,QAAQ;IACR,MAAM;IACN,SAAS;IACT,oCAAoC;IACpC,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,iCAAiC;IACjC,SAAS;AACb;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,sBAAsB,EAAE,0CAA0C;IAClE,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI;qCACiC;AACrC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,4CAA4C;IAC5C,mDAAmD;IACnD,eAAe;IACf,4BAA4B;IAC5B,+BAA+B;IAC/B,sBAAsB,EAAE,0CAA0C;IAClE;;6BAEyB;AAC7B;;AAEA;IACI,cAAc;IACd,4CAA4C;IAC5C,kBAAkB;;IAElB,4BAA4B;IAC5B,+BAA+B;IAC/B,6BAA6B;IAC7B,gCAAgC;IAChC,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,4CAA4C;IAC5C,kBAAkB;IAClB,4BAA4B;IAC5B,+BAA+B;IAC/B,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,4BAA4B;IAC5B,+BAA+B;IAC/B,6BAA6B;IAC7B,gCAAgC;IAChC,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;IAC/B,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;IAC/B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,eAAe;AACnB","sourcesContent":["/* Menu arrow button for sidbar */\n.buttonContainerSidbar {\n    position: fixed;\n    top: 0.8em;\n    right: 25px;\n    z-index: 38;\n}\n\n.menuButton {\n    width: 16px;\n    height: 5vh;\n    cursor: pointer;\n    border: none;\n    filter: invert();\n    padding-right: 0.4em;\n}\n\n.menuButton:active {\n    box-shadow: 0 0 0 0 white;\n    animation: globalPressAnimation 0.1s 1 linear;\n}\n\n.menuButton:hover {\n    filter: invert(48%) sepia(13%) saturate(3207%) hue-rotate(130deg)\n        brightness(95%) contrast(80%);\n}\n\n/* sidbar component */\n\n.sideNavbarText {\n    padding-top: 0.2em;\n    list-style-type: none;\n    text-align: center;\n    padding-left: 0em;\n}\n\n.sideNavbarText h3 {\n    padding: 1em;\n}\n\n.sideNavbarImages {\n    padding-top: 2em;\n    list-style-type: none;\n    text-align: center;\n    padding-left: 0em;\n}\n\n.sideContainerParent {\n    display: flex;\n    align-items: center;\n    position: fixed;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    background-color: var(--sidbarColor);\n    z-index: 37;\n    padding-left: 1em;\n    min-width: 240px;\n    min-height: 100vh;\n    margin: 0;\n    animation: slideIn 0.1s 1 linear;\n}\n\n@keyframes slideIn {\n    0% {\n        min-width: 0px;\n    }\n\n    50% {\n        min-width: 240px;\n    }\n\n    to {\n        min-width: 240px;\n    }\n}\n\n.sideBarSettingsIcon {\n    max-width: 2em;\n}\n\n.sideContainerParentDesktopSmall {\n    display: block;\n    align-items: center;\n    position: fixed;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    background-color: var(--sidbarColor);\n    z-index: 30;\n    padding-left: 0.6em;\n    min-width: 0.5em;\n    min-height: 100vh;\n    animation: slideOut 0.2s 1 linear;\n    margin: 0;\n}\n\n@keyframes slideOut {\n    0% {\n        min-width: 240px;\n    }\n\n    50% {\n        min-width: 0.5em;\n    }\n\n    to {\n        min-width: 0.5em;\n    }\n}\n\n.iconSizeMenu {\n    max-width: 3.5em;\n    padding-right: 0.9em;\n    padding-left: 0.9em;\n    filter: invert();\n    cursor: pointer;\n    box-sizing: border-box; /* Ensure padding does not affect layout */\n    justify-content: center;\n    align-items: center;\n}\n\n.iconSizeMenu:active {\n    animation: globalPressAnimation 0.1s 1 linear;\n}\n\n.iconSizeMenu:hover {\n    filter: invert(48%) sepia(13%) saturate(3207%) hue-rotate(130deg)\n        brightness(95%) contrast(80%);\n}\n\n.sideNavbarTextContainerSmall {\n    padding-top: 8em;\n}\n\n.iconSizeMenuActive {\n    background-color: var(--sidbarSelectorColor);\n    box-shadow: 0 -2px 0 5px var(--sidbarSelectorColor);\n    cursor: pointer;\n    border-top-left-radius: 10px;\n    border-bottom-left-radius: 10px;\n    box-sizing: border-box; /* Ensure padding does not affect layout */\n    transition:\n        background-color 0.2s ease,\n        padding-top 0.2s ease;\n}\n\n.MenuActive {\n    padding: 0.5em;\n    background-color: var(--sidbarSelectorColor);\n    padding-top: 0.8em;\n\n    border-top-left-radius: 10px;\n    border-bottom-left-radius: 10px;\n    border-top-right-radius: 10px;\n    border-bottom-right-radius: 10px;\n    text-align: left;\n    max-height: 2.4em;\n    transform: scale(0.8);\n}\n\n.MenuActiveNo:hover {\n    padding: 0.5em;\n    background-color: var(--sidbarSelectorColor);\n    padding-top: 0.8em;\n    border-top-left-radius: 10px;\n    border-bottom-left-radius: 10px;\n    border-top-right-radius: 10px;\n    border-bottom-right-radius: 10px;\n}\n\n.MenuActiveNo {\n    padding: 0.5em;\n    padding-top: 0.8em;\n    border-top-left-radius: 10px;\n    border-bottom-left-radius: 10px;\n    border-top-right-radius: 10px;\n    border-bottom-right-radius: 10px;\n    text-align: left;\n    max-height: 2.4em;\n    transform: scale(0.8);\n}\n\n.sideNavbarImage {\n    max-height: 5em;\n    padding-bottom: 2em;\n}\n\n.sideNavbarImageSmall {\n    max-height: 5em;\n    padding-bottom: 2em;\n    padding-top: 5em;\n}\n\n.activeLiSide {\n    border-top-left-radius: 10px;\n    border-bottom-left-radius: 10px;\n    cursor: pointer;\n    color: white;\n    font-size: 1.3em;\n    padding-bottom: 1em;\n    display: inline-block;\n    vertical-align: middle;\n}\n\n.notActiveSide {\n    display: inline-block;\n    vertical-align: middle;\n    color: white;\n    font-size: 1.3em;\n    padding-bottom: 1em;\n}\n\n.notActiveSide:hover {\n    border-top-left-radius: 10px;\n    border-bottom-left-radius: 10px;\n    text-align: left;\n    cursor: pointer;\n}\n\n.logoutButtonSideMenu {\n    max-width: 30px;\n    max-height: 30px;\n    filter: invert();\n    cursor: pointer;\n}\n\n.logoutButtonSideMenuSmall {\n    max-width: 30px;\n    max-height: 30px;\n    filter: invert();\n    position: absolute;\n    bottom: 1em;\n    left: 1.2em;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
